import axios from "axios";
import {
  A_LEAD_DETAIL_FETCH_ERR,
  A_LEAD_DETAIL_FETCH_REQUEST,
  A_LEAD_DETAIL_FETCH_SUCCESS,
  LEAD_CREATE_SUBMIT_ERR,
  LEAD_CREATE_SUBMIT_REQUEST,
  LEAD_CREATE_SUBMIT_SUCCESS,
  LEAD_DELETE_ERR,
  LEAD_DELETE_REQUEST,
  LEAD_DELETE_SUCCESS,
  LEAD_EDUCATION_DETAILS_ADD_ERR,
  LEAD_EDUCATION_DETAILS_ADD_REQUEST,
  LEAD_EDUCATION_DETAILS_ADD_SUCCESS,
  LEAD_EDUCATION_DETAILS_DELETE_ERR,
  LEAD_EDUCATION_DETAILS_DELETE_REQUEST,
  LEAD_EDUCATION_DETAILS_DELETE_SUCCESS,
  LEAD_EDUCATION_DETAILS_FIND_ERR,
  LEAD_EDUCATION_DETAILS_FIND_REQUEST,
  LEAD_EDUCATION_DETAILS_FIND_SUCCESS,
  LEAD_EDUCATION_ENGLISH_TEST_DETAILS_DELETE_ERR,
  LEAD_EDUCATION_ENGLISH_TEST_DETAILS_DELETE_REQUEST,
  LEAD_EDUCATION_ENGLISH_TEST_DETAILS_DELETE_SUCCESS,
  LEAD_FIND_ERR,
  LEAD_FIND_REQUEST,
  LEAD_FIND_SUCCESS,
  LEAD_OWNER_CHANGE_ERR,
  LEAD_OWNER_CHANGE_REQUEST,
  LEAD_OWNER_CHANGE_SUCCESS,
  LEAD_PENDING_STATUS_CHANGE_ERR,
  LEAD_PENDING_STATUS_CHANGE_REQUEST,
  LEAD_PENDING_STATUS_CHANGE_SUCCESS,
  FIND_LEAD_PENDING_STATUS_CHANGE_REQUEST,
  FIND_LEAD_PENDING_STATUS_CHANGE_SUCCESS,
  FIND_LEAD_PENDING_STATUS_CHANGE_ERR,
  LEAD_PERSONAL_DETAILS_ADD_ERR,
  LEAD_PERSONAL_DETAILS_ADD_REQUEST,
  LEAD_PERSONAL_DETAILS_ADD_SUCCESS,
  LEAD_PERSONAL_DETAILS_SHOW_ERR,
  LEAD_PERSONAL_DETAILS_SHOW_REQUEST,
  LEAD_PERSONAL_DETAILS_SHOW_SUCCESS,
  LEAD_STATUS_SHOW_ERR,
  LEAD_STATUS_SHOW_REQUEST,
  LEAD_STATUS_SHOW_SUCCESS,
  FIND_APPROVING_LEAD_STATUS_REQUEST,
  FIND_APPROVING_LEAD_STATUS_SUCCESS,
  FIND_APPROVING_LEAD_STATUS_ERR,
  CHANGE_APPROVING_LEAD_STATUS_REQUEST,
  CHANGE_APPROVING_LEAD_STATUS_SUCCESS,
  CHANGE_APPROVING_LEAD_STATUS_ERR,
  LEAD_RESTART_APPLICATION_REQUEST,
  LEAD_RESTART_APPLICATION_SUCCESS,
  LEAD_RESTART_APPLICATION_ERR,
  LEAD_EDIT_SUBMIT_REQUEST,
  LEAD_EDIT_SUBMIT_SUCCESS,
  LEAD_EDIT_SUBMIT_ERR,
  LEAD_BULKUPLOAD_REQUEST,
  LEAD_BULKUPLOAD_SUCCESS,
  LEAD_BULKUPLOAD_ERR,
  LEAD_REGISTRATIONFEE_CREATE_REQUEST,
  LEAD_REGISTRATIONFEE_CREATE_SUCCESS,
  LEAD_REGISTRATIONFEE_CREATE_ERR,
  LEAD_REGISTRATIONFEE_FIND_REQUEST,
  LEAD_REGISTRATIONFEE_FIND_SUCCESS,
  LEAD_REGISTRATIONFEE_FIND_ERR,
  SHORTLIST_VALIDATION_FIND_REQUEST,
  SHORTLIST_VALIDATION_FIND_SUCCESS,
  SHORTLIST_VALIDATION_FIND_ERR,
  LEAD_APPROVAL_REQUEST_FIND_REQUEST,
  LEAD_APPROVAL_REQUEST_FIND_SUCCESS,
  LEAD_APPROVAL_REQUEST_FIND_ERR,
  LEAD_APPROVAL_REQUEST_APPROVE_REQUEST,
  LEAD_APPROVAL_REQUEST_APPROVE_SUCCESS,
  LEAD_APPROVAL_REQUEST_APPROVE_ERR,
  LEAD_APPROVAL_REQUEST_REJECT_REQUEST,
  LEAD_APPROVAL_REQUEST_REJECT_SUCCESS,
  LEAD_APPROVAL_REQUEST_REJECT_ERR,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_FIND_REQUEST,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_FIND_SUCCESS,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_FIND_ERR,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_APPROVE_REQUEST,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_APPROVE_SUCCESS,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_APPROVE_ERR,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_REJECT_REQUEST,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_REJECT_SUCCESS,
  LEAD_OWNERCHANGE_APPROVAL_REQUEST_REJECT_ERR,
  LEAD_CREDENTIAL_RESEND_REQUEST,
  LEAD_CREDENTIAL_RESEND_SUCCESS,
  LEAD_CREDENTIAL_RESEND_ERR,
  LEAD_CREDENTIAL_SETPASSWORD_REQUEST,
  LEAD_CREDENTIAL_SETPASSWORD_SUCCESS,
  LEAD_CREDENTIAL_SETPASSWORD_ERR,
  LEAD_COUNSILORNOTE_CREATE_REQUEST,
  LEAD_COUNSILORNOTE_CREATE_SUCCESS,
  LEAD_COUNSILORNOTE_CREATE_ERR,
  LEAD_TELECALLERNOTE_CREATE_REQUEST,
  LEAD_TELECALLERNOTE_CREATE_SUCCESS,
  LEAD_TELECALLERNOTE_CREATE_ERR,
  LEAD_PERSONAL_DETAILS_ADD_SUCCESS_MESSAGE,
  LEAD_PERSONAL_DETAILS_ADD_ERR_MESSAGE,
  LEAD_DUPLICATE_APPROVAL_FIND_SUCCESS,
  LEAD_DUPLICATE_APPROVAL_FIND_ERR,
  LEAD_DUPLICATE_APPROVAL_FIND_REQUEST,
  LEAD_DUPLICATE_APPROVAL_APPROVE_REQUEST,
  LEAD_DUPLICATE_APPROVAL_APPROVE_SUCCESS,
  LEAD_DUPLICATE_APPROVAL_APPROVE_ERR,
  LEAD_DUPLICATE_APPROVAL_REJECT_REQUEST,
  LEAD_DUPLICATE_APPROVAL_REJECT_SUCCESS,
  LEAD_DUPLICATE_APPROVAL_REJECT_ERR,
  LEAD_DUPLICATE_APPROVAL_FINDONE_REQUEST,
  LEAD_DUPLICATE_APPROVAL_FINDONE_SUCCESS,
  LEAD_DUPLICATE_APPROVAL_FINDONE_ERR,
  LEAD_REFUND_CREATE_REQUEST,
  LEAD_REFUND_CREATE_SUCCESS,
  LEAD_REFUND_CREATE_ERR,
  LEAD_REFUND_FIND_REQUEST,
  LEAD_REFUND_FIND_SUCCESS,
  LEAD_REFUND_FIND_ERR,
  LEAD_REFUND_UPDATE_REQUEST,
  LEAD_REFUND_UPDATE_SUCCESS,
  LEAD_REFUND_UPDATE_ERR,
  LEAD_MARKETING_CREATE_REQUEST,
  LEAD_MARKETING_CREATE_SUCCESS,
  LEAD_MARKETING_CREATE_ERR,
  LEAD_MARKETINGNOTE_CREATE_REQUEST,
  LEAD_MARKETINGNOTE_CREATE_SUCCESS,
  LEAD_MARKETINGNOTE_CREATE_ERR,
  LEAD_PHONENUMBER_VERIFIED_REQUEST,
  LEAD_PHONENUMBER_VERIFIED_SUCCESS,
  LEAD_PHONENUMBER_VERIFIED_ERR,
  LEAD_EMAIL_VERIFIED_REQUEST,
  LEAD_EMAIL_VERIFIED_SUCCESS,
  LEAD_EMAIL_VERIFIED_ERR,
  LEAD_OTP_VERIFY_REQUEST,
  LEAD_OTP_VERIFY_SUCCESS,
  LEAD_OTP_VERIFY_ERR,
  LEAD_PASSPORT_APPROVAL_FIND_REQUEST,
  LEAD_PASSPORT_APPROVAL_FIND_SUCCESS,
  LEAD_PASSPORT_APPROVAL_FIND_ERR,
  LEAD_PASSPORT_APPROVAL_APPROVE_REQUEST,
  LEAD_PASSPORT_APPROVAL_APPROVE_SUCCESS,
  LEAD_PASSPORT_APPROVAL_APPROVE_ERR,
  LEAD_PASSPORT_EDIT_REQUEST,
  LEAD_PASSPORT_EDIT_SUCCESS,
  LEAD_PASSPORT_EDIT_ERR,
  LEAD_PASSPORT_EDIT_FIND_REQUEST,
  LEAD_PASSPORT_EDIT_FIND_SUCCESS,
  LEAD_PASSPORT_EDIT_FIND_ERR,
  LEAD_PASSPORT_EDIT_APPROVE_REQUEST,
  LEAD_PASSPORT_EDIT_APPROVE_SUCCESS,
  LEAD_PASSPORT_EDIT_APPROVE_ERR,
  LEAD_PASSPORT_EDIT_REJECT_REQUEST,
  LEAD_PASSPORT_EDIT_REJECT_SUCCESS,
  LEAD_PASSPORT_EDIT_REJECT_ERR,
  USER_BRANCH_FIND_REQUEST,
  USER_BRANCH_FIND_SUCCESS,
  USER_BRANCH_FIND_ERR,
  LEAD_REFUNDFEE_REJECT_REQUEST,
  LEAD_REFUNDFEE_REJECT_SUCCESS,
  LEAD_ENROLLMENT_APPROVAL_CREATE_REQUEST,
  LEAD_ENROLLMENT_APPROVAL_FIND_REQUST,
  LEAD_ENROLLMENT_APPROVAL_FIND_SUCCESS,
  LEAD_ENROLLMENT_APPROVAL_CREATE_SUCCESS,
  LEAD_ENROLLMENT_APPROVAL_STATUS_CHECK_REQUEST,
  LEAD_ENROLLMENT_APPROVAL_STATUS_CHECK_SUCCESS,
  LEAD_ENROLLMENT_APPROVAL_REQUEST_REJECT_REQUEST,
  LEAD_ENROLLMENT_APPROVAL_REQUEST_REJECT_SUCCESS,
  LEAD_FILTER_REQUEST,
  LEAD_FILTER_FIND_SUCCESS,
  LEAD_FILTER_ERR,
  ALL_LEAD_FIND_ACTION,
  ALL_lEAD_FIND_SUCCESS,
  ALL_LEAD_FIND_REQUEST,
  ALL_LEAD_FIND_SUCCESS,
  DEAD_LEAD_FIND_REQUEST,
  DEAD_LEAD_FIND_SUCCESS,
  RECALLED_LEAD_FIND_REQUEST,
  RECALLED_LEAD_FIND_SUCCESS,
  DEALS_FIND_REQUEST,
  DEALS_FIND_SUCCESS,
  DEFFERAL_LEAD_FIND_REQUEST,
  DEFFERAL_LEAD_FIND_SUCCESS,
  DROP_LEAD_FIND_REQUEST,
  DROP_LEAD_FIND_SUCCESS,
  ENROLLED_LEAD_FIND_SUCCESS,
  ENROLLED_LEAD_FIND_REQUEST,
  ALL_LEAD_WITHOUTPAGINATION_REQUEST,
  ALL_LEAD_WITHOUTPAGINATION_SUCCESS,
  DEAD_LEAD_FIND_WITHOUT_PAGINATION_SUCCESS,
  DEAD_LEAD_FIND_WITHOUT_PAGINATION_REQUEST,
  LEAD_DEAD_FILTER_REQUEST,
  LEAD_DEAD_FILTER_SUCCESS,
  RECALLED_LEAD_FIND_WITHOUT_PAGINATION_REQUEST,
  RECALLED_LEAD_FIND_WITHOUT_PAGINATION_SUCCESS,
  LEAD_RECALLED_FILTER_REQUEST,
  LEAD_RECALLED_FILTER_SUCCESS,
  DEAL_FILTER_REQUEST,
  DEAL_FILTER_SUCCESS,
  DEALS_FIND_WITHOUT_PAGINATION_REQUEST,
  DEALS_FIND_WITHOUT_PAGINATION_SUCCESS,
  DEFERRAL_LEAD_WITHOUT_PAGINATION_FIND_REQUEST,
  DEFERRAL_LEAD_WITHOUT_PAGINATION_FIND_SUCCESS,
  DEFERRAL_FILTER_REQUEST,
  DEFERRAL_FILTER_SUCCESS,
  DROP_LEAD_FIND_WITHOUT_PAGINATION_REQUEST,
  DROP_LEAD_FIND_WITHOUT_PAGINATION_SUCCESS,
  DROP_FILTER_REQUEST,
  DROP_FILTER_SUCCESS,
  ENROLLED_LEAD_WITHOUT_PAGINATION_FIND_REQUEST,
  ENROLLED_LEAD_WITHOUT_PAGINATION_FIND_SUCCESS,
  ENROLLED_FILTER_REQUEST,
  ENROLLED_FILTER_SUCCESS,
} from "../../constants/leadConstant";
import {
  SUCCESS_TRUE_MSG_ERR,
  SUCCESS_TRUE_MSG_SUCCESS,
} from "../../constants/roleManagmentConstant";

// leadAddAction
export const leadAddAction =
  (
    firstName,
    lastName,
    email,
    gender,
    mobileNumber,
    countryCode,
    whatsappNumber,
    location,
    dateOfBirth,
    education,
    leadSource,
    referralName,
    preferredCountry,
    remark,
    profile,
    // newPass,
    // confirmPass,
    countryCodeSecondary,
    secMobileNumber,
    livingCountry,
    isMarried,
    selectedState,
    selectedCity,
    selectedBranch
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_CREATE_SUBMIT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let createdBy = isUserExist.name;
      let createdByID = isUserExist.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/leadAdd",
        {
          firstName,
          lastName,
          email,
          gender,
          mobileNumber,
          countryCode,
          whatsappNumber,
          location,
          dateOfBirth,
          education,
          leadSource,
          referralName,
          preferredCountry,
          remark,
          profile,
          createdBy,
          // newPass,
          // confirmPass,
          countryCodeSecondary,
          secMobileNumber,
          livingCountry,
          isMarried,
          selectedState,
          selectedCity,
          createdByID,
          selectedBranch,
        },
        config
      );

      dispatch({ type: LEAD_CREATE_SUBMIT_SUCCESS, payload: data });

      // let isUserExist = localStorage.getItem("loginInfo")
      //   ? JSON.parse(localStorage.getItem("loginInfo"))
      //   : null;
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({ type: LEAD_CREATE_SUBMIT_ERR, payload: error.response.data });
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: true });
    }
  };

// leadEditAction
export const leadEditAction =
  (
    leadId,
    firstName,
    lastName,
    email,
    gender,
    mobileNumber,
    countryCode,
    whatsappNumber,
    location,
    dateOfBirth,
    education,
    leadSource,
    referralName,
    preferredCountry,
    remark,
    profile,
    newPass,
    confirmPass,
    selectedCountry,
    isMarried,
    selectedState,
    selectedCity,
    selectedBranch
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_EDIT_SUBMIT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let createdBy = isUserExist.name;
      let updatedByID = isUserExist.UserId;

      let { data } = await axios.put(
        `/api/admin/lead/leadEdit?id=${leadId}`,
        {
          firstName,
          lastName,
          email,
          gender,
          mobileNumber,
          countryCode,
          whatsappNumber,
          location,
          dateOfBirth,
          education,
          leadSource,
          referralName,
          preferredCountry,
          remark,
          profile,
          createdBy,
          newPass,
          confirmPass,
          selectedCountry,
          isMarried,
          selectedState,
          selectedCity,
          updatedByID,
          selectedBranch,
        },
        config
      );

      dispatch({ type: LEAD_EDIT_SUBMIT_SUCCESS, payload: data });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({ type: LEAD_EDIT_SUBMIT_ERR, payload: error.response.data });
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
    }
  };

export const allLeadFindActionWithoutPagination = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ALL_LEAD_WITHOUTPAGINATION_REQUEST })    

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };
        
    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/allleadFindwithoutpagination?id=${UserId}`,
      config
    );    
    
    dispatch({ type: ALL_LEAD_WITHOUTPAGINATION_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

export const allLeadsFindAction = (limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: ALL_LEAD_FIND_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };
        
    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/allleadFind?id=${UserId}&limit=${limit}&pageNumber=${pageNumber}`,
      config
    );

    console.log(440, data);
    
    dispatch({ type: ALL_LEAD_FIND_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

export const deadLeadFindWithoutPaginationAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DEAD_LEAD_FIND_WITHOUT_PAGINATION_REQUEST })    

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/deadleadFindwithoutpagination?id=${UserId}`,
      config
    );

    dispatch({ type: DEAD_LEAD_FIND_WITHOUT_PAGINATION_SUCCESS, payload: data })

  } catch(error) {
    console.error(error);
  }
}

export const deadLeadFindAction = (limit, pageNumber) => async (dispatch, getState) => {
  try {    
    dispatch({ type: DEAD_LEAD_FIND_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/deadleadFind?id=${UserId}&limit=${limit}&pageNumber=${pageNumber}`,
      config
    );

    dispatch({ type: DEAD_LEAD_FIND_SUCCESS, payload: data })

  } catch(error) {
    console.error(error);
  }
}

export const recalledLeadFindWithoutPaginationAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: RECALLED_LEAD_FIND_WITHOUT_PAGINATION_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/recalledleadfindwithoutpagination?id=${UserId}`,
      config
    );

    dispatch({ type: RECALLED_LEAD_FIND_WITHOUT_PAGINATION_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

export const recalledLeadFindAction = (limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: RECALLED_LEAD_FIND_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/recalledleadfind?id=${UserId}&limit=${limit}&pageNumber=${pageNumber}`,
      config
    );

    dispatch({ type: RECALLED_LEAD_FIND_SUCCESS, payload: data })
  } catch (error) {
    console.error(error);
  }
}

export const dealsFindActionWithoutPagination = () => async (dispatch, getState) => {
  try {    
    dispatch({ type: DEALS_FIND_WITHOUT_PAGINATION_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/dealsfindwithoutpagination?id=${UserId}`,
      config
    );    
    
    dispatch({ type: DEALS_FIND_WITHOUT_PAGINATION_SUCCESS, payload: data})
  } catch(error) {
    console.error(error);
  }
}

export const dealsFindAction = (limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: DEALS_FIND_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/dealsfind?id=${UserId}&limit=${limit}&pageNumber=${pageNumber}`,
      config
    );    

    console.log(606,data);
    
    
    dispatch({ type: DEALS_FIND_SUCCESS, payload: data })

  } catch (error) {
    console.error(error);
  }
}

export const deferralLeadWithoutPaginationFindAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DEFERRAL_LEAD_WITHOUT_PAGINATION_FIND_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/defferalleadwithoutpaginationfind?id=${UserId}`,
      config
    );    

    dispatch({ type: DEFERRAL_LEAD_WITHOUT_PAGINATION_FIND_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

export const deferralLeadFindAction = (limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: DEFFERAL_LEAD_FIND_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/defferalleadfind?id=${UserId}&limit=${limit}&pageNumber=${pageNumber}`,
      config
    );           

    dispatch({ type: DEFFERAL_LEAD_FIND_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

export const dropLeadFindWithoutPaginationAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DROP_LEAD_FIND_WITHOUT_PAGINATION_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;    

    let { data } = await axios.get(
      `/api/admin/lead/dropleadwithoutpaginationfind?id=${UserId}`,
      config
    );    

    dispatch({ type: DROP_LEAD_FIND_WITHOUT_PAGINATION_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

export const dropLeadFindAction = (limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: DROP_LEAD_FIND_REQUEST })
    
    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;    

    let { data } = await axios.get(
      `/api/admin/lead/dropleadfind?id=${UserId}&limit=${limit}&pageNumber=${pageNumber}`,
      config
    );

    dispatch({ type: DROP_LEAD_FIND_SUCCESS, payload: data })

  } catch(error) {
    console.error(error);
  }
}

export const enrolledLeadWithoutPaginationFindAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: ENROLLED_LEAD_WITHOUT_PAGINATION_FIND_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/enrolledleadwithoutpaginationfind?id=${UserId}`,
      config
    );
    
    dispatch({ type: ENROLLED_LEAD_WITHOUT_PAGINATION_FIND_SUCCESS, payload: data })
  } catch (error) {
    console.error(error);
  }
}

export const enrolledLeadFindAction = (limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: ENROLLED_LEAD_FIND_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;    

    let { data } = await axios.get(
      `/api/admin/lead/enrolledleadfind?id=${UserId}&limit=${limit}&pageNumber=${pageNumber}`,
      config
    );

    dispatch({ type: ENROLLED_LEAD_FIND_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

// leadFindAction
export const leadFindAction = (limit, pageNumber, leadType) => async (dispatch, getState) => {
  try {
    dispatch({ type: LEAD_FIND_REQUEST });        

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;    

    let { data } = await axios.get(
      `/api/admin/lead/leadFind?id=${UserId}&limit=${limit}&pageNumber=${pageNumber}&leadType=${leadType}`,
      config
    );

    dispatch({ type: LEAD_FIND_SUCCESS, payload: data });
  } catch (error) {
    console.log(error.response, "error.response");
    dispatch({ type: LEAD_FIND_ERR, payload: error.response.data });
  }
};

export const deferralFilterAction = (filters, limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: DEFERRAL_FILTER_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
        "Content-Type": "application/json",
      },
    };

    let UserId = isUserExist?.UserId;
    const requestBody = { ...filters, UserId };

    let { data } = await axios.post(
      `/api/admin/lead/deferralfilter?id=${UserId}&limit=${limit}&pagenumber=${pageNumber}`,
      requestBody,
      config
    )

    dispatch({ type: DEFERRAL_FILTER_SUCCESS, payload: data })
  } catch (error) {
    console.error(error);
  }
}

export const dropFilterAction = (filters, limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: DROP_FILTER_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
        "Content-Type": "application/json",
      },
    };

    let UserId = isUserExist?.UserId;
    const requestBody = { ...filters, UserId };

    let { data } = await axios.post(
      `/api/admin/lead/dropfilter?id=${UserId}&limit=${limit}&pagenumber=${pageNumber}`,
      requestBody,
      config
    )    

    dispatch({ type: DROP_FILTER_SUCCESS, payload: data })
  } catch(error) {
    console.error(error)
  }
}

export const enrolledFilterAction = (filters, limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: ENROLLED_FILTER_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
        "Content-Type": "application/json",
      },
    };

    let UserId = isUserExist?.UserId;
    const requestBody = { ...filters, UserId };

    let { data } = await axios.post(
      `/api/admin/lead/enrolledfilter?id=${UserId}&limit=${limit}&pagenumber=${pageNumber}`,
      requestBody,
      config
    )

    dispatch({ type: ENROLLED_FILTER_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

export const dealFilterAction = (filters, limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: DEAL_FILTER_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
        "Content-Type": "application/json",
      },
    };

    let UserId = isUserExist?.UserId;
    const requestBody = { ...filters, UserId };

    let { data } = await axios.post(
      `/api/admin/lead/dealfilter?id=${UserId}&limit=${limit}&pagenumber=${pageNumber}`,
      requestBody,
      config
    )

    console.log(620,"filter data",data);
    
    dispatch({ type: DEAL_FILTER_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

// leadFilterAction
export const leadFilterAction = (filters, limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: LEAD_FILTER_REQUEST });

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
        "Content-Type": "application/json",
      },
    };

    let UserId = isUserExist?.UserId;
    const requestBody = { ...filters, UserId };

    let { data } = await axios.post(
      `/api/admin/lead/leadFilter?id=${UserId}&limit=${limit}&pagenumber=${pageNumber}`,
      requestBody,
      config
    )

    dispatch({ type: LEAD_FILTER_FIND_SUCCESS, payload: data });
  } catch (error) {
    console.error(error.response, "error.response");
    dispatch({
      type: LEAD_FILTER_ERR,
      payload: error.response?.data || "Something went wrong",
    });
  }
};

export const recalledLeadFilterAction = (filters, limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: LEAD_RECALLED_FILTER_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
        "Content-Type": "application/json",
      },
    };

    let UserId = isUserExist?.UserId;
    const requestBody = { ...filters, UserId };
    
    let { data } = await axios.post(
      `/api/admin/lead/recalledleadfilter?id=${UserId}&limit=${limit}&pagenumber=${pageNumber}`,
      requestBody,
      config
    );

    dispatch({ type: LEAD_RECALLED_FILTER_SUCCESS, payload: data })
  } catch(error) {
    console.error(error);
  }
}

export const deadLeadFilterAction = (filters, limit, pageNumber) => async (dispatch, getState) => {
  try {
    dispatch({ type: LEAD_DEAD_FILTER_REQUEST })

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
        "Content-Type": "application/json",
      },
    };

    let UserId = isUserExist?.UserId;
    const requestBody = { ...filters, UserId };

    let { data } = await axios.post(
      `/api/admin/lead/deadleadfilter?id=${UserId}&limit=${limit}&pagenumber=${pageNumber}`,
      requestBody,
      config
    );
    
    dispatch({ type: LEAD_DEAD_FILTER_SUCCESS, payload: data })

  } catch(error) {
    console.error(error);
  }
}

// deleteLeadAction
export const deleteLeadAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: LEAD_DELETE_REQUEST });

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let { data } = await axios.delete(
      `/api/admin/lead/leadDelete?id=${id}`,
      config
    );

    dispatch({ type: LEAD_DELETE_SUCCESS, payload: data });

    // let isUserExist = localStorage.getItem("loginInfo")
    //   ? JSON.parse(localStorage.getItem("loginInfo"))
    //   : null;
  } catch (error) {
    console.log(error.response, "error.response");
    dispatch({ type: LEAD_DELETE_ERR, payload: error.response.data });
  }
};

// leadDetailFetchAction
export const leadDetailFetchAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: A_LEAD_DETAIL_FETCH_REQUEST });

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let { data } = await axios.get(
      `/api/admin/lead/leadDetailFetch?id=${id}`,
      config
    );

    dispatch({ type: A_LEAD_DETAIL_FETCH_SUCCESS, payload: data })

  } catch (error) {
    dispatch({ type: A_LEAD_DETAIL_FETCH_ERR, payload: error.response.data });
  }
}

// leadPersonalDetailsAddAction
export const leadPersonalDetailsAddAction =
  (formValues, id) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PERSONAL_DETAILS_ADD_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      const userName = isUserExist?.name;
      const employeeId = isUserExist?.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/leadPersonalDetailsAdd",
        { formValues, id, userName, employeeId },
        config
      );

      dispatch({ type: LEAD_PERSONAL_DETAILS_ADD_SUCCESS, payload: data });
      dispatch({
        type: LEAD_PERSONAL_DETAILS_ADD_SUCCESS_MESSAGE,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PERSONAL_DETAILS_ADD_ERR,
        payload: error.response.data,
      });

      dispatch({
        type: LEAD_PERSONAL_DETAILS_ADD_ERR_MESSAGE,
        payload: error.response.data,
      });
    }
  };

// leadPersonalDetailsShowAction
export const leadPersonalDetailsShowAction =
  (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PERSONAL_DETAILS_SHOW_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let { data } = await axios.get(
        `/api/admin/lead/leadPersonalDetailsShow?id=${id}`,
        config
      );

      dispatch({ type: LEAD_PERSONAL_DETAILS_SHOW_SUCCESS, payload: data });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PERSONAL_DETAILS_SHOW_ERR,
        payload: error.response.data,
      });
    }
  };

// leadEnrollmentApprovalCreateAction
export const leadEnrollmentApprovalCreateAction =
  (userId, visaReceivedDate, appliedApplicationId, leadId) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_ENROLLMENT_APPROVAL_CREATE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;
      let taskOwnerId = isUserExist?.UserId;

      const body = {
        userId: userId,
        visaReceivedDate: visaReceivedDate,
        appliedApplicationId: appliedApplicationId,
        taskOwner: taskOwner,
        taskOwnerId: taskOwnerId,
      };

      let { data } = await axios.post(
        `/api/admin/lead/leadenrollapprovalcreate`,
        body,
        config
      );

      dispatch({
        type: LEAD_ENROLLMENT_APPROVAL_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  };

// leadOwnerChangeAction
export const leadOwnerChangeAction =
  (
    bulkLeadId,
    selectedLeadId,
    branchId,
    managerId,
    status,
    appliedApplicationId,
    appliedId,
    universityGivenId,
    visaSummary,
    visaDetails,
    declarationForm,
    component
  ) =>
  async (dispatch, getState) => {
    try {
      const body = {
        bulkLeadId,
        selectedLeadId,
        branchId,
        managerId,
        status,
        appliedApplicationId,
        appliedId,
        universityGivenId,
        visaSummary,
        visaDetails,
        declarationForm,
        component
      }
      console.log(634,body);
      
      dispatch({ type: LEAD_OWNER_CHANGE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;
      let taskOwnerId = isUserExist?.UserId;

      // if (status === "visaDetails") {
      //   visaDetails = visaDetails ?? {}; // Ensures visaDetails is an object
      //   visaDetails.UserId = isUserExist?.UserId;
      // }

      let { data } = await axios.put(
        `/api/admin/lead/leadOwnerChange`,
        {
          branchId,
          managerId,
          bulkLeadId,
          selectedLeadId,
          status,
          appliedApplicationId,
          universityGivenId,
          visaSummary,
          taskOwner,
          visaDetails,
          declarationForm,
          component,
          taskOwnerId,
        },
        config
      );

      console.log(676,data);
      

      if (data?.status === true && data?.data === "Enrolled") {
        await axios.delete(
          `/api/admin/lead/enrollmentapprovalRequestRejected?applicationid=${appliedId}&&leadid=${selectedLeadId}`,
          config
        );
      }

      dispatch({ type: LEAD_OWNER_CHANGE_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: LEAD_OWNER_CHANGE_ERR,
        payload: error.response.data,
      });
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: true });
    }
  };

// leadChangeStatusAction
export const leadChangeStatusAction =
  (status, id, reason, menu, intakeMonth, intakeYear) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_STATUS_SHOW_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;
      let employeeId = isUserExist?.UserId;

      let { data } = await axios.patch(
        `/api/admin/lead/leadStatusChange?id=${id}`,
        {
          status: status,
          taskOwner: taskOwner,
          reason: reason,
          menu: menu,
          intakeMonth: intakeMonth,
          intakeYear: intakeYear,
          employeeId: employeeId,
        },
        config
      );

      dispatch({ type: LEAD_STATUS_SHOW_SUCCESS, payload: data });
      dispatch({ type: SUCCESS_TRUE_MSG_SUCCESS, payload: true });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_STATUS_SHOW_ERR,
        payload: error.response.data,
      });
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: true });
    }
  };

// leadEducationDetailsAddAction
export const leadEducationDetailsAddAction =
  (
    qualificationName,
    highSecField,
    highSchoolCompletionYear,
    highSchoolBoard,
    highSchoolScore,
    higherSecondaryCompletionYear,
    higherSecondarySteam,
    higherSecondaryBoard,
    higherSecondaryScore,
    academicDetails,
    englishTestDetails,
    id
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_EDUCATION_DETAILS_ADD_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;
      let employeeId = isUserExist?.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/leadEducationAdd",
        {
          qualificationName,
          highSecField,
          highSchoolCompletionYear,
          highSchoolBoard,
          highSchoolScore,
          higherSecondaryCompletionYear,
          higherSecondarySteam,
          higherSecondaryBoard,
          higherSecondaryScore,
          academicDetails,
          englishTestDetails,
          id,
          taskOwner,
          employeeId,
        },
        config
      );

      dispatch({ type: LEAD_EDUCATION_DETAILS_ADD_SUCCESS, payload: data });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_EDUCATION_DETAILS_ADD_ERR,
        payload: error.response.data,
      });
    }
  };

// leadEducationDetailsShowAction
export const leadEducationDetailsShowAction =
  (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_EDUCATION_DETAILS_FIND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let { data } = await axios.get(
        `/api/admin/lead/leadEducationDetailsShow?id=${id}`,
        config
      );

      dispatch({ type: LEAD_EDUCATION_DETAILS_FIND_SUCCESS, payload: data });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_EDUCATION_DETAILS_FIND_ERR,
        payload: error.response.data,
      });
    }
  };

// deleteAcademicDetailsAction
export const deleteAcademicDetailsAction =
  (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_EDUCATION_DETAILS_DELETE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let { data } = await axios.delete(
        `/api/admin/lead/deleteAcademicDetail?id=${id}`,
        config
      );

      dispatch({ type: LEAD_EDUCATION_DETAILS_DELETE_SUCCESS, payload: data });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_EDUCATION_DETAILS_DELETE_ERR,
        payload: error.response.data,
      });
    }
  };

// deleteEnglishTestAction
export const deleteEnglishTestAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: LEAD_EDUCATION_ENGLISH_TEST_DETAILS_DELETE_REQUEST });

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let { data } = await axios.delete(
      `/api/admin/lead/deleteEnglishTestDetail?id=${id}`,
      config
    );

    dispatch({
      type: LEAD_EDUCATION_ENGLISH_TEST_DETAILS_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error.response, "error.response");
    dispatch({
      type: LEAD_EDUCATION_ENGLISH_TEST_DETAILS_DELETE_ERR,
      payload: error.response.data,
    });
  }
};

// LEAD PENDING DOCS STATUS

// pendingLeadStatusDocsAction
export const pendingLeadStatusDocsAction =
  (id, status, docName, reason, leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PENDING_STATUS_CHANGE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };
      let taskOwner = isUserExist?.name;
      let { data } = await axios.post(
        "/api/admin/lead/addPendingStatusLeadChange",
        { id, status, taskOwner, docName, reason, leadId },
        config
      );

      dispatch({
        type: LEAD_PENDING_STATUS_CHANGE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PENDING_STATUS_CHANGE_ERR,
        payload: error.response.data,
      });
    }
  };

// findPendingStatusLeadChange
export const findPendingStatusLeadChangeAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: FIND_LEAD_PENDING_STATUS_CHANGE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };
      // let taskOwner = isUserExist?.name;
      let { data } = await axios.get(
        "/api/admin/lead/findPendingStatusLeadChange",
        config
      );

      dispatch({
        type: FIND_LEAD_PENDING_STATUS_CHANGE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: FIND_LEAD_PENDING_STATUS_CHANGE_ERR,
        payload: error.response.data,
      });
    }
  };

// FIND STATUS APPROVING LIST

// findApprovingStatusLeadAction

export const findApprovingStatusLeadAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: FIND_APPROVING_LEAD_STATUS_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };
      let taskOwner = isUserExist?.UserId;
      let { data } = await axios.get(
        `/api/admin/lead/findApprovingStatusLead?branchManger=${taskOwner}`,
        config
      );

      dispatch({
        type: FIND_APPROVING_LEAD_STATUS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: FIND_APPROVING_LEAD_STATUS_ERR,
        payload: error.response.data,
      });
    }
  };

// leadStatusApprovingChangeAction
export const leadStatusApprovingChangeAction =
  (status, leadId, statusId, requestStatus) => async (dispatch, getState) => {
    try {
      dispatch({ type: CHANGE_APPROVING_LEAD_STATUS_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };
      let taskOwner = isUserExist?.name;
      let taskOwnerId = isUserExist?.UserId;
      let { data } = await axios.post(
        "/api/admin/lead/changeApprovingStatusLead",
        { status, leadId, statusId, requestStatus, taskOwner, taskOwnerId },
        config
      );

      dispatch({
        type: CHANGE_APPROVING_LEAD_STATUS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: CHANGE_APPROVING_LEAD_STATUS_ERR,
        payload: error.response.data,
      });
    }
  };

// LEAD RESTART APPLICATION FROM DEFERRAL

// leadRestartApplicationAction
export const leadRestartApplicationAction =
  (leadId, requestStatus) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_RESTART_APPLICATION_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      // let taskOwner = isUserExist?.UserId;
      let { data } = await axios.put(
        `/api/admin/lead/leadRestartApplication?id=${leadId}`,
        { requestStatus },
        config
      );

      dispatch({
        type: LEAD_RESTART_APPLICATION_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_RESTART_APPLICATION_ERR,
        payload: error.response.data,
      });
    }
  };

// leadRegistrationFee create action

export const leadRegistrationFeeCreateAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_REGISTRATIONFEE_CREATE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      let leadID = isUserExist?.UserId;
      let taskOwner = isUserExist?.name;

      let { data } = await axios.post(
        `/api/admin/lead/registrationFee?userID=${leadID}&taskOwner=${taskOwner}`,
        formData,
        config
      );

      dispatch({
        type: LEAD_REGISTRATIONFEE_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_REGISTRATIONFEE_CREATE_ERR,
        payload: error.response.data,
      });
    }
  };

// leadRegistrationFee find action

export const leadRegistrationFeeFindAction =
  (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_REGISTRATIONFEE_FIND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let leadID = isUserExist?.UserId;

      let { data } = await axios.get(
        `/api/admin/lead/registrationFeeFind?leadID=${id}`,
        config
      );

      dispatch({
        type: LEAD_REGISTRATIONFEE_FIND_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_REGISTRATIONFEE_FIND_ERR,
        payload: error.response.data,
      });
    }
  };

// ::::::::::BulkUpload lead :::::::::::::::::::

// Lead bulkUploadAction

export const leadBulkUploadAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_BULKUPLOAD_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const userId = isUserExist.UserId;

      // let taskOwner = isUserExist?.UserId;
      let { data } = await axios.post(
        `/api/admin/lead/bulkUploadForLeads?id=${userId}`,
        formData,
        config
      );

      dispatch({
        type: LEAD_BULKUPLOAD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_BULKUPLOAD_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead shortListApply validation

export const leadShortlistApplyValidationAction =
  (leadId, country) => async (dispatch, getState) => {
    try {
      dispatch({ type: SHORTLIST_VALIDATION_FIND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      const userId = isUserExist.UserId;
      // let taskOwner = isUserExist?.UserId;
      let { data } = await axios.post(
        "/api/admin/lead/shortListApplyValidate",
        {
          leadId,
          country,
        },
        config
      );

      dispatch({
        type: SHORTLIST_VALIDATION_FIND_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: SHORTLIST_VALIDATION_FIND_ERR,
        payload: error.response.data,
      });
    }
  };

// :::::::::::::::::::::::::::::: LEAD EDIT APPROVAL REQUEST FIND :::::::::::::::::::::::::::::::::::::::::

// Action for find approval request

export const leadApprovalRequestFindAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_APPROVAL_REQUEST_FIND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      const userId = isUserExist.UserId;

      // let taskOwner = isUserExist?.UserId;
      let { data } = await axios.get(
        `/api/admin/lead/findApprovalRequest?userID=${userId}`,
        config
      );

      dispatch({
        type: LEAD_APPROVAL_REQUEST_FIND_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_APPROVAL_REQUEST_FIND_ERR,
        payload: error.response.data,
      });
    }
  };

// Action for approve lead edit approval request

export const leadApprovalRequestApproveAction =
  (leadApprovalID) => async (dispatch, getState) => {
    try {
            
      dispatch({ type: LEAD_APPROVAL_REQUEST_APPROVE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.post(
        "/api/admin/lead/approvalRequestApprove",
        { taskOwner, leadApprovalID },
        config
      );

      dispatch({
        type: LEAD_APPROVAL_REQUEST_APPROVE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_APPROVAL_REQUEST_APPROVE_ERR,
        payload: error.response.data,
      });
    }
  };

export const leadEnrollmentApprovalRejectAction =
  (applicationId, leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_ENROLLMENT_APPROVAL_REQUEST_REJECT_REQUEST });
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let { data } = await axios.delete(
        `/api/admin/lead/enrollmentapprovalRequestRejected?applicationid=${applicationId}&&leadid=${leadId}`,
        config
      );

      dispatch({
        type: LEAD_ENROLLMENT_APPROVAL_REQUEST_REJECT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  };

// Action for approve lead edit reject request
export const leadApprovalRequestRejectAction =
  (leadTableID, reason) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_APPROVAL_REQUEST_REJECT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/approvalRequestRejected",
        { taskOwner, leadTableID, reason },
        config
      );

      dispatch({
        type: LEAD_APPROVAL_REQUEST_REJECT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_APPROVAL_REQUEST_REJECT_ERR,
        payload: error.response.data,
      });
    }
  };

// :::::::::::::::::::::::::::::: LEAD ENROLLMENT APPROVAL REQUEST FIND :::::::::::::::::::::::::::::::::::::::::
export const leadEnrollmentApprovalFindAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_ENROLLMENT_APPROVAL_FIND_REQUST });
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      const userId = isUserExist.UserId;
      let taskOwner = isUserExist?.name;

      let { data } = await axios.get(
        `/api/admin/lead/findEnrollmentApprovalRequest?userId=${userId}&&taskowner=${taskOwner}`,
        config
      );

      dispatch({ type: LEAD_ENROLLMENT_APPROVAL_FIND_SUCCESS, payload: data });
    } catch (error) {
      console.error(error);
    }
  };

// :::::::::::::::::::::::::::::: LEAD OWNERCHANGE APPROVAL REQUEST FIND :::::::::::::::::::::::::::::::::::::::::

export const leadOwnerChangeRequestFindAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_FIND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      const userId = isUserExist.UserId;

      let { data } = await axios.get(
        `/api/admin/lead/findOwnerChangeApprovalRequest?userId=${userId}`,
        config
      );

      dispatch({
        type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_FIND_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_FIND_ERR,
        payload: error.response.data,
      });
    }
  };

// Action for approve lead edit approval request

export const leadOwnerChangeApprovalRequestApproveAction =
  (leadID, tableID) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_APPROVE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.post(
        "/api/admin/lead/OwnerChangeApproveRequest",
        { taskOwner, leadID, tableID },
        config
      );

      dispatch({
        type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_APPROVE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_APPROVE_ERR,
        payload: error.response.data,
      });
    }
  };

// Action for approve lead edit reject request

export const leadOwnerChangeApprovalRequestRejectAction =
  (id, leadID, reason) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_REJECT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/OwnerChangeRejectRequest",
        { taskOwner, id, leadID, reason },
        config
      );

      dispatch({
        type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_REJECT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_OWNERCHANGE_APPROVAL_REQUEST_REJECT_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Resend credentials Action

export const leadResendCredentialAction =
  (leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_CREDENTIAL_RESEND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };
      let taskOwner = isUserExist?.name;
      let { data } = await axios.post(
        "/api/admin/lead/resendCredentials",
        { leadId, taskOwner },
        config
      );

      dispatch({
        type: LEAD_CREDENTIAL_RESEND_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_CREDENTIAL_RESEND_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead set credentials Action

export const leadSetCredentialAction =
  (password, leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_CREDENTIAL_SETPASSWORD_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.post(
        "/api/admin/lead/setLeadPassword",
        { password, leadId, taskOwner },
        config
      );

      dispatch({
        type: LEAD_CREDENTIAL_SETPASSWORD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_CREDENTIAL_SETPASSWORD_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead CounsilorNote create Action

export const leadCounsilorNoteCreateAction =
  (leadId, counsilorNote, date, currentTime) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_COUNSILORNOTE_CREATE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;
      let designationId = isUserExist?.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/counsilorNoteCreate",
        { leadId, counsilorNote, date, currentTime, taskOwner, designationId },
        config
      );

      dispatch({
        type: LEAD_COUNSILORNOTE_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_COUNSILORNOTE_CREATE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead TeleCallerNote create Action

export const leadTelecallerNoteCreateAction =
  (leadId, TelecallerNote, date, currentTime) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_TELECALLERNOTE_CREATE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;
      let desigNationId = isUserExist?.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/telecallerNoteCreate",
        { leadId, TelecallerNote, date, currentTime, taskOwner, desigNationId },
        config
      );

      dispatch({
        type: LEAD_TELECALLERNOTE_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_TELECALLERNOTE_CREATE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Marketing note create Action

export const leadMarketingNoteCreateAction =
  (leadId, marketingNote, date, currentTime) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_MARKETINGNOTE_CREATE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;
      let desigNationId = isUserExist?.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/marketingNoteCreate",
        { leadId, marketingNote, date, currentTime, taskOwner, desigNationId },
        config
      );

      dispatch({
        type: LEAD_MARKETINGNOTE_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_MARKETINGNOTE_CREATE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Duplicate approval find Action

export const leadDuplicateApprovalFindAction =
  (isPartner) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_DUPLICATE_APPROVAL_FIND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      const userId = isUserExist.UserId;

      let { data } = await axios.get(
        `/api/admin/lead/duplicateApproval?userId=${userId}&isPartner=${isPartner}`,
        config
      );

      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_FIND_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_FIND_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Duplicate approval findOne Action

export const leadDuplicateApprovalFindOneAction =
  (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_DUPLICATE_APPROVAL_FINDONE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.get(
        `/api/admin/lead/duplicateApprovalFindOne?id=${id}`,
        config
      );

      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_FINDONE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_FINDONE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Duplicate approval approve Action

export const leadDuplicateApproveAction =
  (leadApprovalId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_DUPLICATE_APPROVAL_APPROVE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/duplicateLeadApprove",
        {
          leadApprovalId,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_APPROVE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_APPROVE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Duplicate approval reject Action

export const leadDuplicateRejectAction =
  (leadApprovalId, reason) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_DUPLICATE_APPROVAL_REJECT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/duplicateLeadReject",
        {
          leadApprovalId,
          reason,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_REJECT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_REJECT_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Refund create Action

export const leadRefundCreateAction =
  (currency, refundAmount, leadId, applicationId) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_REFUND_CREATE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/createRefund",
        {
          currency,
          refundAmount,
          leadId,
          applicationId,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_REFUND_CREATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_REFUND_CREATE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Refund find Action

export const leadRefundFindAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: LEAD_REFUND_FIND_REQUEST });

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let taskOwner = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/findRefundApproval?userId=${taskOwner}`,
      config
    );

    dispatch({
      type: LEAD_REFUND_FIND_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error.response, "error.response");
    dispatch({
      type: LEAD_REFUND_FIND_ERR,
      payload: error.response.data,
    });
  }
};

// lead Refund Fee Rejection Action
export const leadRefundFeeRejectionAction =
  (lead, refundId, reason) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_REFUNDFEE_REJECT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      const body = {
        lead: lead,
        reason: reason,
        refundId: refundId,
        taskOwner: isUserExist?.name,
      };

      let { data } = await axios.post(
        "/api/admin/lead/leadrefundreject",
        body,
        config
      );

      dispatch({
        type: LEAD_REFUNDFEE_REJECT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error(error);
    }
  };

// Lead Refund Approval Action
export const leadRefundApprovalAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: LEAD_REFUND_FIND_REQUEST });

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let taskOwner = isUserExist?.name;

    let { data } = await axios.put(
      `/api/admin/lead/refundApproval?id=${id}&taskOwner?=${taskOwner}`,
      {},
      config
    );

    dispatch({
      type: LEAD_REFUND_FIND_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error.response, "error.response");
    dispatch({
      type: LEAD_REFUND_FIND_ERR,
      payload: error.response.data,
    });
  }
};

// Lead Refund Update Action

export const leadRefundUpdateAction =
  (currency, amount, id) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_REFUND_UPDATE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.UserId;

      let { data } = await axios.put(
        "/api/admin/lead/updateRefund",
        {
          currency,
          amount,
          id,
        },
        config
      );

      dispatch({
        type: LEAD_REFUND_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_REFUND_UPDATE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead PhoneNumber verified Action

export const leadPhoneNumberVerifiedAction =
  (leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PHONENUMBER_VERIFIED_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/verifyPhoneNumber",
        {
          leadId,
        },
        config
      );

      dispatch({
        type: LEAD_PHONENUMBER_VERIFIED_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PHONENUMBER_VERIFIED_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Email verified Action

export const leadEmailVerifiedAction =
  (leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_EMAIL_VERIFIED_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.UserId;

      let { data } = await axios.post(
        "/api/admin/lead/verifyEmail",
        {
          leadId,
        },
        config
      );

      dispatch({
        type: LEAD_EMAIL_VERIFIED_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_EMAIL_VERIFIED_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Otp verified Action

export const leadOtpVerifyAction =
  (otp, id, verificationType) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_OTP_VERIFY_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.post(
        "/api/admin/lead/otpVerification",
        {
          otp,
          id,
          verificationType,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_OTP_VERIFY_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_OTP_VERIFY_ERR,
        payload: error.response.data,
      });
    }
  };

// :::::::::::::::::::::::::::::: LEAD PASSPORT APPROVAL REQUEST FIND :::::::::::::::::::::::::::::::::::::::::

// Action for find approval request

export const leadPassportApprovalRequestFindAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PASSPORT_APPROVAL_FIND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.UserId;
      let { data } = await axios.get(
        `/api/admin/lead/findPassportApprovalRequest?taskOwner=${taskOwner}`,
        config
      );

      dispatch({
        type: LEAD_PASSPORT_APPROVAL_FIND_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PASSPORT_APPROVAL_FIND_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Duplicate approval approve Action

export const leadPassportApprovalRequestApproveAction =
  (leadId, personalDetailsId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PASSPORT_APPROVAL_APPROVE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/passportVerifyApprove",
        {
          leadId,
          personalDetailsId,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_PASSPORT_APPROVAL_APPROVE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PASSPORT_APPROVAL_APPROVE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Duplicate approval reject Action

export const leadPassportApprovalRejectAction =
  (leadId, personalDetailsId, reason) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_DUPLICATE_APPROVAL_REJECT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/passportVerifyReject",
        {
          leadId,
          personalDetailsId,
          reason,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_REJECT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_DUPLICATE_APPROVAL_REJECT_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Passport edit request Action

export const leadPassportEditRequestAction =
  (leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PASSPORT_EDIT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/passportEditRequest",
        {
          leadId,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_PASSPORT_EDIT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PASSPORT_EDIT_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Passport edit request find Action

export const leadPassportEditFindRequestAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PASSPORT_EDIT_FIND_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.UserId;

      let { data } = await axios.get(
        `/api/admin/lead/passportEditRequestFind?taskOwner=${taskOwner}`,
        config
      );

      dispatch({
        type: LEAD_PASSPORT_EDIT_FIND_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PASSPORT_EDIT_FIND_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Passport edit request approve Action

export const leadPassportEditApproveRequestAction =
  (id, leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PASSPORT_EDIT_APPROVE_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/passportEditRequestApprove",
        {
          id,
          leadId,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_PASSPORT_EDIT_APPROVE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PASSPORT_EDIT_APPROVE_ERR,
        payload: error.response.data,
      });
    }
  };

// Lead Passport edit request reject Action

export const leadPassportEditRejectRequestAction =
  (id, leadId) => async (dispatch, getState) => {
    try {
      dispatch({ type: LEAD_PASSPORT_EDIT_REJECT_REQUEST });

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let taskOwner = isUserExist?.name;

      let { data } = await axios.put(
        "/api/admin/lead/passportEditRequestReject",
        {
          id,
          leadId,
          taskOwner,
        },
        config
      );

      dispatch({
        type: LEAD_PASSPORT_EDIT_REJECT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.log(error.response, "error.response");
      dispatch({
        type: LEAD_PASSPORT_EDIT_REJECT_ERR,
        payload: error.response.data,
      });
    }
  };

// UserBranch Find Action

export const UserBranchFindAction = (userId) => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_BRANCH_FIND_REQUEST });

    let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    // let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/lead/userBranchFind?userId=${userId}`,
      config
    );

    dispatch({
      type: USER_BRANCH_FIND_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error.response, "error.response");
    dispatch({
      type: USER_BRANCH_FIND_ERR,
      payload: error.response.data,
    });
  }
};
